import { render, staticRenderFns } from "./V9Penggunaan.vue?vue&type=template&id=15d7d32c&"
import script from "./V9Penggunaan.vue?vue&type=script&lang=js&"
export * from "./V9Penggunaan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports